import triggerQuantityChange from '../helpers/qty-change';

(function (document, $, undefined) {
	const cartPage = {};

	cartPage.init = function () {
		this.triggerQuantityChange();
	};

	cartPage.triggerQuantityChange = function () {
		triggerQuantityChange();
	};

	$(document).ready(function () {
		cartPage.init();
	});
	$(document.body).on('updated_wc_div', function () {
		cartPage.init();
	});
})(document, jQuery);
